import { render, staticRenderFns } from "./dialog-note-list.vue?vue&type=template&id=68dcea00&scoped=true"
import script from "./dialog-note-list.vue?vue&type=script&lang=js"
export * from "./dialog-note-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcea00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68dcea00')) {
      api.createRecord('68dcea00', component.options)
    } else {
      api.reload('68dcea00', component.options)
    }
    module.hot.accept("./dialog-note-list.vue?vue&type=template&id=68dcea00&scoped=true", function () {
      api.rerender('68dcea00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list-note/dialog-note-list.vue"
export default component.exports